"use client"

/* eslint-disable react/no-unescaped-entities */
import { Drawer, DrawerContent } from "@/components/ui/drawer"
import { Sheet, SheetContent } from "@/components/ui/sheet"
import { useIsMobile } from "@/hooks/use-is-mobile"
import { useEffect, useRef, useState } from "react"
import { MiniCartContent } from "./new-minicart-components/minicart-content"
import { MiniCartFooter } from "./new-minicart-components/minicart-footer"
import { MiniCartHeader } from "./new-minicart-components/minicart-header"
import { useCrossData } from "./use-cross-data"
import { useMiniCartData } from "./use-mini-cart-data"
import { useMiniCartStore } from "./use-new-minicart-store"

export default function NewMinicart() {
  const open = useMiniCartStore((state) => state?.dialogOpen)
  const setOpen = useMiniCartStore((state) => state?.setDialogOpen)
  const [isMounted, setIsMounted] = useState(false)

  const { refetch, miniCartLoading, grandTotal, productList, total_quantity } =
    useMiniCartData({
      open,
    })
  const headerRef = useRef<HTMLDivElement>(null)

  const { crossData, loading: crossDataLoading } = useCrossData({
    open,
    productList,
  })

  const { isMobile } = useIsMobile()

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return null
  }

  if (isMobile) {
    return (
      <Drawer direction="bottom" open={open} onOpenChange={setOpen}>
        {/* @ts-expect-error - Explain WHY you're ignoring this error */}
        <DrawerContent
          className="h-[calc(100vh-100px)] rounded-t-[20px] p-0 supports-[height:100dvh]_h-[calc(100dvh-100px)]"
          showCloseButton={false}
        >
          <div
            className="absolute right-3 top-4  flex h-9 w-9 items-center justify-center rounded-[50%] bg-[#EDEEF0]"
            onClick={() => {
              setOpen(false)
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="lucide lucide-x text-black h-6 w-6"
              viewBox="0 0 24 24"
            >
              <path d="M18 6 6 18M6 6l12 12" />
            </svg>
          </div>
          <MiniCartHeader
            grandTotal={grandTotal}
            cartQuantity={total_quantity}
            ref={headerRef}
          />
          <MiniCartContent
            miniCartLoading={miniCartLoading}
            productList={productList}
            crossData={crossData}
            crossDataLoading={crossDataLoading}
            refetch={refetch}
            headerRef={headerRef}
          />
          {total_quantity > 0 && <MiniCartFooter grandTotal={grandTotal} />}
        </DrawerContent>
      </Drawer>
    )
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent
        className="flex max-w-[500px] flex-col gap-0 rounded-l-[10px] p-0 sm_max-w-[500px]"
        side="right"
      >
        <MiniCartHeader
          grandTotal={grandTotal}
          cartQuantity={total_quantity}
          ref={headerRef}
        />
        <MiniCartContent
          miniCartLoading={miniCartLoading}
          productList={productList}
          crossData={crossData}
          crossDataLoading={crossDataLoading}
          refetch={refetch}
          headerRef={headerRef}
        />
        {Array.isArray(productList) && productList?.length ? (
          <MiniCartFooter grandTotal={grandTotal} />
        ) : null}
      </SheetContent>
    </Sheet>
  )
}
